export default {
      id: "engine_badge-usage",
      viewBox: "0 0 75 64",
      url: __webpack_public_path__ + "img/icons.svg#engine_badge",
      toString: function () {
        return this.url;
      }
    }